import { Input } from '@hub-la/shadcn'
import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SelectDateRangeCalendar } from '../../components/select-date-range-calendar'
import { SelectOffers } from '../../components/select-offers'
import { SelectPaymentMethod } from '../../components/select-payment-method'
import { SelectType } from '../../components/select-type'
import { SelectUtm } from '../../components/select-utm'
import { ConfirmExportModal } from './confirm-export-modal'
import { SelectStatus } from './select-status'

export const Filters = ({ setFilters, filters, offers, isLoading }) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col md:flex-row justify-between gap-3">
      <div className="flex flex-col w-full md:w-auto md:flex-row flex-wrap gap-3">
        <div className="relative h-10">
          <Search className="absolute w-4 h-4 right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground z-10" />
          <Input
            type="text"
            placeholder={t('search')}
            className="md:w-[250px] w-full"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value, page: 1 })}
          />
        </div>
        <SelectOffers
          offers={offers}
          value={filters.offerIds}
          onChange={(value) => setFilters((prevState) => ({ ...prevState, offerIds: value, page: 1 }))}
          isLoading={isLoading}
        />
        <SelectDateRangeCalendar filters={filters} setFilters={setFilters} />
        <SelectStatus
          value={filters.statuses}
          onChange={(value) => setFilters((prevState) => ({ ...prevState, statuses: value, page: 1 }))}
        />
        <SelectPaymentMethod filters={filters} setFilters={setFilters} />
        <SelectType filters={filters} setFilters={setFilters} />
        <SelectUtm filters={filters} setFilters={setFilters} />
      </div>
      <div className="flex flex-col justify-between w-full md:w-auto md:flex-row md:justify-end gap-3">
        <ConfirmExportModal filters={filters} offers={offers} />
      </div>
    </div>
  )
}
